import { render, staticRenderFns } from "./ExwarehouseAdd.vue?vue&type=template&id=f93af008&scoped=true&"
import script from "./ExwarehouseAdd.vue?vue&type=script&lang=ts&"
export * from "./ExwarehouseAdd.vue?vue&type=script&lang=ts&"
import style0 from "./ExwarehouseAdd.vue?vue&type=style&index=0&id=f93af008&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93af008",
  null
  
)

export default component.exports